import type { VariantImagesDefinition } from 'types/images'

import { F01_IMAGES } from './default'

export const F01_MEMOJI_PURPLE_IMAGES = {
  ...F01_IMAGES,
  experience: {
    background: {
      ...F01_IMAGES.experience.background,
      srcSet: [
        '/images/f01/memoji-purple/experience.webp',
        '/images/f01/memoji-purple/experience@2x.webp',
      ],
    },
  },
  experiencePitch: {
    pitch: {
      ...F01_IMAGES.experiencePitch.pitch,
      srcSet: [
        '/images/f01/memoji-purple/experience_pitch.webp',
        '/images/f01/memoji-purple/experience_pitch@2x.webp',
      ],
    },
  },
  flexible: {
    background: {
      ...F01_IMAGES.flexible.background,
      srcSet: [
        '/images/f01/memoji-purple/flexible.webp',
        '/images/f01/memoji-purple/flexible@2x.webp',
      ],
    },
  },
  stairsCardio: {
    background: {
      ...F01_IMAGES.stairsCardio.background,
      srcSet: [
        '/images/f01/memoji-purple/stairs_cardio.webp',
        '/images/f01/memoji-purple/stairs_cardio@2x.webp',
      ],
    },
  },
  howOftenExercise: {
    background: {
      ...F01_IMAGES.howOftenExercise.background,
      srcSet: [
        '/images/f01/memoji-purple/how_often_exercise.webp',
        '/images/f01/memoji-purple/how_often_exercise@2x.webp',
      ],
    },
  },
  howOftenWalks: {
    background: {
      ...F01_IMAGES.howOftenWalks.background,
      srcSet: [
        '/images/f01/memoji-purple/how_often_walks.webp',
        '/images/f01/memoji-purple/how_often_walks@2x.webp',
      ],
    },
  },
  mainGoal: {
    getToned: {
      ...F01_IMAGES.mainGoal.getToned,
      srcSet: [
        '/images/f01/memoji-purple/goal/main_goal_option_get_toned.webp',
        '/images/f01/memoji-purple/goal/main_goal_option_get_toned@2x.webp',
      ],
    },
    improveFitness: {
      ...F01_IMAGES.mainGoal.improveFitness,
      srcSet: [
        '/images/f01/memoji-purple/goal/main_goal_option_improve_fitness.webp',
        '/images/f01/memoji-purple/goal/main_goal_option_improve_fitness@2x.webp',
      ],
    },
    loseWeight: {
      ...F01_IMAGES.mainGoal.loseWeight,
      srcSet: [
        '/images/f01/memoji-purple/goal/main_goal_option_lose_weight.webp',
        '/images/f01/memoji-purple/goal/main_goal_option_lose_weight@2x.webp',
      ],
    },
  },
  bodyTypePitch: {
    endomorph: {
      ...F01_IMAGES.bodyTypePitch.endomorph,
      srcSet: [
        '/images/f01/memoji-purple/body-type-pitch/body_type_pitch_endomorph.webp',
        '/images/f01/memoji-purple/body-type-pitch/body_type_pitch_endomorph@2x.webp',
      ],
    },
    mesomorph: {
      ...F01_IMAGES.bodyTypePitch.mesomorph,
      srcSet: [
        '/images/f01/memoji-purple/body-type-pitch/body_type_pitch_mesomorph.webp',
        '/images/f01/memoji-purple/body-type-pitch/body_type_pitch_mesomorph@2x.webp',
      ],
    },
    ectomorph: {
      ...F01_IMAGES.bodyTypePitch.ectomorph,
      srcSet: [
        '/images/f01/memoji-purple/body-type-pitch/body_type_pitch_ectomorph.webp',
        '/images/f01/memoji-purple/body-type-pitch/body_type_pitch_ectomorph@2x.webp',
      ],
    },
  },
  physicalBuild: {
    extended: {
      ...F01_IMAGES.physicalBuild.extended,
      srcSet: [
        '/images/f01/memoji-purple/physical-build/physical_build_option_extended.webp',
        '/images/f01/memoji-purple/physical-build/physical_build_option_extended@2x.webp',
      ],
    },
    fullfigured: {
      ...F01_IMAGES.physicalBuild.fullfigured,
      srcSet: [
        '/images/f01/memoji-purple/physical-build/physical_build_option_fullfigured.webp',
        '/images/f01/memoji-purple/physical-build/physical_build_option_fullfigured@2x.webp',
      ],
    },
    midsized: {
      ...F01_IMAGES.physicalBuild.midsized,
      srcSet: [
        '/images/f01/memoji-purple/physical-build/physical_build_option_midsized.webp',
        '/images/f01/memoji-purple/physical-build/physical_build_option_midsized@2x.webp',
      ],
    },
    slim: {
      ...F01_IMAGES.physicalBuild.slim,
      srcSet: [
        '/images/f01/memoji-purple/physical-build/physical_build_option_slim.webp',
        '/images/f01/memoji-purple/physical-build/physical_build_option_slim@2x.webp',
      ],
    },
  },
  bigResultsPitch: {
    first: {
      ...F01_IMAGES.bigResultsPitch.first,
      srcSet: [
        '/images/f01/memoji-purple/big-results-pitch/big_results_pitch_01.webp',
        '/images/f01/memoji-purple/big-results-pitch/big_results_pitch_01@2x.webp',
      ],
    },
    second: {
      ...F01_IMAGES.bigResultsPitch.second,
      srcSet: [
        '/images/f01/memoji-purple/big-results-pitch/big_results_pitch_02.webp',
        '/images/f01/memoji-purple/big-results-pitch/big_results_pitch_02@2x.webp',
      ],
    },
    third: {
      ...F01_IMAGES.bigResultsPitch.third,
      srcSet: [
        '/images/f01/memoji-purple/big-results-pitch/big_results_pitch_03.webp',
        '/images/f01/memoji-purple/big-results-pitch/big_results_pitch_03@2x.webp',
      ],
    },
    mockup: {
      ...F01_IMAGES.bigResultsPitch.mockup,
      srcSet: [
        '/images/f01/memoji-purple/big-results-pitch/big_results_pitch_mockup_{{locale}}.webp',
        '/images/f01/memoji-purple/big-results-pitch/big_results_pitch_mockup_{{locale}}@2x.webp',
      ],
    },
  },
  socialProofMillions: {
    pitch: {
      ...F01_IMAGES.socialProofMillions.pitch,
      srcSet: [
        '/images/f01/memoji-purple/social_proof_millions.webp',
        '/images/f01/memoji-purple/social_proof_millions@2x.webp',
      ],
    },
    group: {
      ...F01_IMAGES.socialProofMillions.group,
      srcSet: [
        '/images/f01/memoji-purple/social-proof-millions/group.webp',
        '/images/f01/memoji-purple/social-proof-millions/group@2x.webp',
      ],
    },
  },
  struggle: {
    back: {
      ...F01_IMAGES.struggle.back,
      srcSet: [
        '/images/f01/memoji-purple/struggle/struggle_option_back.webp',
        '/images/f01/memoji-purple/struggle/struggle_option_back@2x.webp',
      ],
    },
    knees: {
      ...F01_IMAGES.struggle.knees,
      srcSet: [
        '/images/f01/memoji-purple/struggle/struggle_option_knees.webp',
        '/images/f01/memoji-purple/struggle/struggle_option_knees@2x.webp',
      ],
    },
    none: {
      ...F01_IMAGES.struggle.none,
      srcSet: [
        '/images/f01/memoji-purple/struggle/struggle_option_none.webp',
        '/images/f01/memoji-purple/struggle/struggle_option_none@2x.webp',
      ],
    },
  },
  strugglePitch: {
    knees: {
      ...F01_IMAGES.strugglePitch.knees,
      srcSet: [
        '/images/f01/memoji-purple/struggle-pitch/struggle_pitch_knees.webp',
        '/images/f01/memoji-purple/struggle-pitch/struggle_pitch_knees@2x.webp',
      ],
    },
    back: {
      ...F01_IMAGES.strugglePitch.back,
      srcSet: [
        '/images/f01/memoji-purple/struggle-pitch/struggle_pitch_back.webp',
        '/images/f01/memoji-purple/struggle-pitch/struggle_pitch_back@2x.webp',
      ],
    },
    both: {
      ...F01_IMAGES.strugglePitch.both,
      srcSet: [
        '/images/f01/memoji-purple/struggle-pitch/struggle_pitch_both.webp',
        '/images/f01/memoji-purple/struggle-pitch/struggle_pitch_both@2x.webp',
      ],
    },
  },
  problemAreas: {
    belly: {
      ...F01_IMAGES.problemAreas.belly,
      srcSet: [
        '/images/f01/memoji-purple/problem-areas/problem_areas_option_belly.webp',
        '/images/f01/memoji-purple/problem-areas/problem_areas_option_belly@2x.webp',
      ],
    },
    butt: {
      ...F01_IMAGES.problemAreas.butt,
      srcSet: [
        '/images/f01/memoji-purple/problem-areas/problem_areas_option_butt.webp',
        '/images/f01/memoji-purple/problem-areas/problem_areas_option_butt@2x.webp',
      ],
    },
    chest: {
      ...F01_IMAGES.problemAreas.chest,
      srcSet: [
        '/images/f01/memoji-purple/problem-areas/problem_areas_option_chest.webp',
        '/images/f01/memoji-purple/problem-areas/problem_areas_option_chest@2x.webp',
      ],
    },
    legs: {
      ...F01_IMAGES.problemAreas.legs,
      srcSet: [
        '/images/f01/memoji-purple/problem-areas/problem_areas_option_legs.webp',
        '/images/f01/memoji-purple/problem-areas/problem_areas_option_legs@2x.webp',
      ],
    },
    arms: {
      ...F01_IMAGES.problemAreas.arms,
      srcSet: [
        '/images/f01/memoji-purple/problem-areas/problem_areas_option_arms.webp',
        '/images/f01/memoji-purple/problem-areas/problem_areas_option_arms@2x.webp',
      ],
    },
  },
  problemAreasPitch: {
    mockup: {
      ...F01_IMAGES.problemAreasPitch.mockup,
      srcSet: [
        '/images/f01/memoji-purple/problem-areas-pitch/problem_areas_pitch_mockup_{{locale}}.webp',
        '/images/f01/memoji-purple/problem-areas-pitch/problem_areas_pitch_mockup_{{locale}}@2x.webp',
      ],
    },
  },
  waterIntake: {
    header: {
      ...F01_IMAGES.waterIntake.header,
      srcSet: [
        '/images/f01/memoji-purple/water_intake.webp',
        '/images/f01/memoji-purple/water_intake@2x.webp',
      ],
    },
  },
  sleepDuration: {
    header: {
      ...F01_IMAGES.sleepDuration.header,
      srcSet: [
        '/images/f01/memoji-purple/sleep_duration.webp',
        '/images/f01/memoji-purple/sleep_duration@2x.webp',
      ],
    },
  },
  bodyGoal: {
    thin: {
      ...F01_IMAGES.bodyGoal.thin,
      srcSet: [
        '/images/f01/memoji-purple/body-goal/body_goal_option_thin.webp',
        '/images/f01/memoji-purple/body-goal/body_goal_option_thin@2x.webp',
      ],
    },
    toned: {
      ...F01_IMAGES.bodyGoal.toned,
      srcSet: [
        '/images/f01/memoji-purple/body-goal/body_goal_option_toned.webp',
        '/images/f01/memoji-purple/body-goal/body_goal_option_toned@2x.webp',
      ],
    },
    curvy: {
      ...F01_IMAGES.bodyGoal.curvy,
      srcSet: [
        '/images/f01/memoji-purple/body-goal/body_goal_option_curvy.webp',
        '/images/f01/memoji-purple/body-goal/body_goal_option_curvy@2x.webp',
      ],
    },
    average: {
      ...F01_IMAGES.bodyGoal.average,
      srcSet: [
        '/images/f01/memoji-purple/body-goal/body_goal_option_average.webp',
        '/images/f01/memoji-purple/body-goal/body_goal_option_average@2x.webp',
      ],
    },
  },
  welcomeAgeBuckets: {
    heroBackground: {
      ...F01_IMAGES.welcomeAgeBuckets.heroBackground,
      srcSet: [
        '/images/f01/memoji-purple/welcome-age-buckets/hero_background.webp',
        '/images/f01/memoji-purple/welcome-age-buckets/hero_background@2x.webp',
      ],
    },
    heroBackgroundDesktop: {
      ...F01_IMAGES.welcomeAgeBuckets.heroBackgroundDesktop,
      srcSet: [
        '/images/f01/memoji-purple/welcome-age-buckets/hero_background_desktop.webp',
        '/images/f01/memoji-purple/welcome-age-buckets/hero_background_desktop@2x.webp',
      ],
    },
  },
  timeBreakfast: {
    header: {
      ...F01_IMAGES.timeBreakfast.header,
      srcSet: [
        '/images/f01/memoji-purple/time_breakfast.webp',
        '/images/f01/memoji-purple/time_breakfast@2x.webp',
      ],
    },
  },
  timeLunch: {
    header: {
      ...F01_IMAGES.timeLunch.header,
      srcSet: [
        '/images/f01/memoji-purple/time_lunch.webp',
        '/images/f01/memoji-purple/time_lunch@2x.webp',
      ],
    },
  },
  timeDinner: {
    header: {
      ...F01_IMAGES.timeDinner.header,
      srcSet: [
        '/images/f01/memoji-purple/time_dinner.webp',
        '/images/f01/memoji-purple/time_dinner@2x.webp',
      ],
    },
  },
  wellnessProfile: {
    extended: {
      ...F01_IMAGES.wellnessProfile.extended,
      srcSet: [
        '/images/f01/memoji-purple/wellness-profile/wellness_profile_extended.webp',
        '/images/f01/memoji-purple/wellness-profile/wellness_profile_extended@2x.webp',
      ],
    },
    fullFigured: {
      ...F01_IMAGES.wellnessProfile.fullFigured,
      srcSet: [
        '/images/f01/memoji-purple/wellness-profile/wellness_profile_fullfigured.webp',
        '/images/f01/memoji-purple/wellness-profile/wellness_profile_fullfigured@2x.webp',
      ],
    },
    midSized: {
      ...F01_IMAGES.wellnessProfile.midSized,
      srcSet: [
        '/images/f01/memoji-purple/wellness-profile/wellness_profile_midsized.webp',
        '/images/f01/memoji-purple/wellness-profile/wellness_profile_midsized@2x.webp',
      ],
    },
    slim: {
      ...F01_IMAGES.wellnessProfile.slim,
      srcSet: [
        '/images/f01/memoji-purple/wellness-profile/wellness_profile_slim.webp',
        '/images/f01/memoji-purple/wellness-profile/wellness_profile_slim@2x.webp',
      ],
    },
  },
  subscription: {
    beforeExtended: {
      ...F01_IMAGES.subscription.beforeExtended,
      srcSet: [
        '/images/f01/memoji-purple/subscription/goal-body/paywall_comparison_before_extended.webp',
        '/images/f01/memoji-purple/subscription/goal-body/paywall_comparison_before_extended@2x.webp',
      ],
    },
    beforeFullfigured: {
      ...F01_IMAGES.subscription.beforeFullfigured,
      srcSet: [
        '/images/f01/memoji-purple/subscription/goal-body/paywall_comparison_before_fullfigured.webp',
        '/images/f01/memoji-purple/subscription/goal-body/paywall_comparison_before_fullfigured@2x.webp',
      ],
    },
    beforeMidsized: {
      ...F01_IMAGES.subscription.beforeMidsized,
      srcSet: [
        '/images/f01/memoji-purple/subscription/goal-body/paywall_comparison_before_midsized.webp',
        '/images/f01/memoji-purple/subscription/goal-body/paywall_comparison_before_midsized@2x.webp',
      ],
    },
    beforeSlim: {
      ...F01_IMAGES.subscription.beforeSlim,
      srcSet: [
        '/images/f01/memoji-purple/subscription/goal-body/paywall_comparison_before_slim.webp',
        '/images/f01/memoji-purple/subscription/goal-body/paywall_comparison_before_slim@2x.webp',
      ],
    },
    afterThin: {
      ...F01_IMAGES.subscription.afterThin,
      srcSet: [
        '/images/f01/memoji-purple/subscription/goal-body/paywall_comparison_after_thin.webp',
        '/images/f01/memoji-purple/subscription/goal-body/paywall_comparison_after_thin@2x.webp',
      ],
    },
    afterToned: {
      ...F01_IMAGES.subscription.afterToned,
      srcSet: [
        '/images/f01/memoji-purple/subscription/goal-body/paywall_comparison_after_toned.webp',
        '/images/f01/memoji-purple/subscription/goal-body/paywall_comparison_after_toned@2x.webp',
      ],
    },
    afterCurvy: {
      ...F01_IMAGES.subscription.afterCurvy,
      srcSet: [
        '/images/f01/memoji-purple/subscription/goal-body/paywall_comparison_after_curvy.webp',
        '/images/f01/memoji-purple/subscription/goal-body/paywall_comparison_after_curvy@2x.webp',
      ],
    },
    afterAverage: {
      ...F01_IMAGES.subscription.afterAverage,
      srcSet: [
        '/images/f01/memoji-purple/subscription/goal-body/paywall_comparison_after_average.webp',
        '/images/f01/memoji-purple/subscription/goal-body/paywall_comparison_after_average@2x.webp',
      ],
    },
  },
  consistencyPitch: {
    pitch: {
      ...F01_IMAGES.consistencyPitch.pitch,
      srcSet: [
        '/images/f01/memoji-purple/consistency-pitch/consistency_pitch.webp',
        '/images/f01/memoji-purple/consistency-pitch/consistency_pitch@2x.webp',
      ],
    },
  },
} satisfies VariantImagesDefinition<typeof F01_IMAGES>
